module.exports = __webpack_public_path__ + "img/logo.873414d5.png";